import store from '~/redux/store';

const requestAssistedPurchase = async (axios, searchValue, page, limit, params = {}) => {
    const { user } = store.getState();

    const response = await axios.get('/assisted-purchases', {
        params: {
            companyId: user.company.id,
            size: limit,
            page,
        },
    });

    const { data } = response;

    const paginationData = {
        pageNumber: data.pageable.pageNumber,
        totalPages: data.totalPages,
    };

    const { content } = data;

    return {
        paginationData,
        result: content.map(assistedPurchase => ({
            label: assistedPurchase.description,
            key: assistedPurchase.id,
            item: assistedPurchase,
        })),
    };
};

export default requestAssistedPurchase;
